import { StarIcon } from './Flame';
import { StreakDot } from './StreakDot';

export function MiniStat({
  label,
  value,
  icon,
  streak,
}: {
  label: string;
  value: string;
  icon?: 'dot' | 'star';
  streak?: number;
}) {
  return (
    <div className="ministat">
      <div className="ministat__label">{label}</div>
      <div className="ministat__value">
        {icon === 'dot' && <StreakDot streak={streak ?? 0} />}
        {icon === 'star' && <StarIcon />}
        {value}
      </div>
    </div>
  );
}
